<template>
  <div id="m-protocol">
    <MHead ref="mhead" @slideto="slideChangeFn"></MHead>
    <div class="m-pbanner"></div>
    <div class="m-protocol-content">
      <pre v-html="content" class="protocol-detail"></pre>
    </div>
  </div>
</template>

<script>
import MHead from "@/components/mobile/m-head";
import { protocolDetail } from "@/proxy/index"
import { mapState } from "vuex";
import { isPc } from "@/util/index"

export default {
  components: {
    MHead,
  },
  data() {
    return {
      content: "",
    };
  },
  computed: {
    ...mapState(["_myData"])
  },
  created () {
      // if(isPc()) {
      //   const id = this.$route.query.id;
      //   this.$router.push({name: 'protocol', query: {id}})
      //   return false;
      // }

      window.scrollTo({
        top: 0,
      });
      protocolDetail(this.$route.query.id).then(res => {
        if (res.data.code == 0) {
          const data = res.data.data
          this.content = data.content
        }
      })
  },
  methods: {
    // 点击回到m-home页
    slideChangeFn(index) {
      // this.$router.push({name: 'm-home', query: {index}})
      this.$router.push({name: 'home', query: {index}})
    },
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/views/mobile/m-protocol.scss";
</style>
